// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3KzCx","paramInput":"JobSimulator_paramInput__1nAl9","input":"JobSimulator_input__1q3M7"};